import axios from'axios';

/**
 * la classe che gestirà i dati delle carte in entrata 
 */
export default {
	tranz: {}, //Il translation set
	dati: {
		glpic: { //i dati della picture gl
			width: 20,  //grandezza dell'immagine'
			height: -1,
			dimx: 400,  //elementi ()quadratoni)
//			dimx: 100,  //elementi ()quadratoni)
			dimy: -1,
			durata: 120, //durata del filmato 
			slid: [0.2, 0.2, 0.2],
		},
		camera: { //i dati riguardo la camera
			cpos: [0, 0, 26], //posizione della camera
			tpos: [0, 0, 0], //target
			rot: [0, 0, 0], //rotazione camera assi x,y,z
		},
	}, //i 
	events: {}, //eventi vari

	//FUNCTIONS*******************
	/** 
	Questa funzione va chiamata all'inizio per rendere disponibile il set di traduzioni corrente
	*/
	initTrans: function() {
		//EVENTI
		//Evento che indica le traduzioni sono state caricate
		this.events.transEvent = new Event('transEvent');
		//FINE EVENTI
		this.readTranslations(); //legge le traduzioni

	},

	/**legge le traduzioni dal php che genera un file json di coppia lemma-traduzione 
	eg. <br>
	{<br>
		'man':'uomo',<br>
		'name': 'nome'<br>
	}<br>
	*/	
	readTranslations: function() {
		let r_app = this;
		return new Promise((resolve, reject) => {
			axios.get('/ap/trans') //Che balle gaver dovu trovar questo!! 
				.then(response => {
					r_app.tranz = response.data;
					//mandiamo l'evento che la traduzione è stata caricata
					document.dispatchEvent(r_app.events.transEvent);
					resolve(response);
				}).catch(err => {
					reject(err);
				});
		});
	},
}